// extracted by mini-css-extract-plugin
export default {"homecontainer":"Home_homecontainer__GKFfo"};